let components = [];

export function VideoSoundToggle(rootDom) {
    const selector = {
        ACTIVE: '_active',
    };
    const $video = $(rootDom).siblings('video');

    if (!$video.length) return;

    // HANDLERS
    $(rootDom).on('click', onToggleSound);

    // PRIVATE
    function onToggleSound(e) {
        $video.prop('muted') ? soundOn() : soundOff();

        // Отменяем переход если кнопка внутри ссылки
        e.preventDefault();
        return false;
    }

    function soundOn() {
        $('video').prop('muted', true);
        $('.js-video-sound-toggle').removeClass(selector.ACTIVE);
        $video.prop('muted', false);
        $(rootDom).addClass(selector.ACTIVE);
    }

    function soundOff() {
        $video.prop('muted', true);
        $(rootDom).removeClass(selector.ACTIVE);
    }

    // PUBLIC
    function destroy() {
        $video.off('click', onToggleSound);
    }

    return {
        destroy
    };
}

// Инициализируем компонента
function init(e, data) {
    const pageContainerDom = data.next.container;

    components = Array.from(pageContainerDom.querySelectorAll('.js-video-sound-toggle')).map(VideoSoundToggle);
}

App.W.on("barba:afterEnter", init);
App.W.on('barba:leave', () => {
    if (components.length) {
        components.forEach(component => component.destroy());
        components = [];
    }
});



// WEBPACK FOOTER //
// ./_src/js/modules/VideoSoundToggle.js